import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiInfo } from '../../../models/api-info';
import { environment } from '../../../../environments/environment';


@Injectable()
export class ApiInfoService {

  constructor(private http: HttpClient) { }

  info(): Observable<ApiInfo> {
    return this.http.get<ApiInfo>(environment.pisteBaseUrl + '/info', {withCredentials: true });
  }
}
